import { useState, type ReactNode } from "react";
import { createPortal, flushSync } from "react-dom";
import { DataSciLogo } from "./DataSciLogo";

export function ReportExport({ title, subtitle, children, disabled = false }: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  disabled?: boolean;
}) {
  const [issuedAt, setIssuedAt] = useState(() => new Date());

  function printReport() {
    flushSync(() => setIssuedAt(new Date()));
    document.body.dataset.printReport = "true";
    try {
      window.print();
    } finally {
      delete document.body.dataset.printReport;
    }
  }

  return (
    <>
      <div className="report-actions">
        <h2>{title}</h2>
        <button type="button" className="btn btn-secondary" onClick={printReport} disabled={disabled}>Imprimir / salvar PDF</button>
      </div>
      {children}
      {createPortal(
        <article className="report-print-copy" aria-hidden="true">
          <header className="report-print-copy__header">
            <DataSciLogo />
            <span>DataSci · Relatório institucional</span>
          </header>
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
          <p className="report-print-copy__date">Emitido em <time dateTime={issuedAt.toISOString()}>{issuedAt.toLocaleString("pt-BR")}</time></p>
          {children}
          <footer className="report-print-copy__footer">
            <DataSciLogo small />
            <span>DataSci · contato@datasci.com.br</span>
          </footer>
        </article>,
        document.body,
      )}
    </>
  );
}
